function initCollectionLoadMore(root = document) {
  const button = root.querySelector("[data-load-more]");
  if (!button || button.dataset.loadMoreBound === "true") return;

  button.dataset.loadMoreBound = "true";
  button.addEventListener("click", async () => {
    const nextUrl = button.getAttribute("data-next-url");
    const grid = document.querySelector("[data-collection-grid]");
    if (!nextUrl || !grid || button.disabled) return;

    button.disabled = true;
    button.classList.add("is-loading");

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error("Load more failed");

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const nextGrid = doc.querySelector("[data-collection-grid]");
      const nextButton = doc.querySelector("[data-load-more]");

      if (nextGrid) {
        Array.from(nextGrid.children).forEach((card) => {
          grid.appendChild(card);
        });
      }

      if (nextButton?.getAttribute("data-next-url")) {
        button.setAttribute("data-next-url", nextButton.getAttribute("data-next-url"));
        button.disabled = false;
        button.classList.remove("is-loading");
        return;
      }

      button.closest("[data-collection-load-more]")?.remove();
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove("is-loading");
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initCollectionLoadMore());
} else {
  initCollectionLoadMore();
}
